import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { useEffect } from 'react';
import { api } from '../services/api';
import { useAuthStore } from '../store/authStore';

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  useEffect(() => {
    const dir = i18n.language === 'he' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  const toggleLanguage = async () => {
    const newLang = i18n.language === 'he' ? 'en' : 'he';
    await i18n.changeLanguage(newLang);
    localStorage.setItem('tsi_language', newLang);

    if (isAuthenticated) {
      try {
        await api.updateLanguage(newLang);
      } catch {
        // ignore
      }
    }
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-1.5 px-2 py-1.5 text-sm text-surface-500 hover:bg-surface-100 rounded-lg transition-colors"
      title={i18n.language === 'he' ? t('language.switchToEnglish') : t('language.switchToHebrew')}
    >
      <Globe size={16} />
      <span className="hidden md:inline text-xs font-medium">
        {i18n.language === 'he' ? 'EN' : 'HE'}
      </span>
    </button>
  );
}
